module.exports = __webpack_public_path__ + "img/0Q3B2213_WoodMatted_MockedUp.1cc5486e.jpg";